import type { FaireProductEntity } from "../../entity_types/product";

export const p_nsdexrcdpf: FaireProductEntity = {
  token: "p_nsdexrcdpf",
  type: "product",
  name: "Champagne Tower Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/391f27dd1efa58c6de59a9c349f623ca474eff8e10d09a26e2d735c5ffee5c79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6743aec45ab3721948d3e9ff4565d7446ecfbead8936510b2e1f4fd49d109ac.jpeg",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:23.161Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
